module.exports = __webpack_public_path__ + "img/footer-image@1.5x.f5f48843.png";